import { createContext } from "react";
import type { CheckDetailState } from "./types";

const CheckDetailContext = createContext<CheckDetailState>({
  isCollapsed: true,
  isEditing: false,
  checkDetailUuid: undefined,
  displayPayFrom: null,
  displayPayTo: null,
  displayMemo: null,
  displayAmount: null,
  displayCheckDate: null,
  displayCheckNumber: null,
  editPayFrom: "",
  editPayTo: "",
  editMemo: "",
  editAmount: "",
  editCheckDate: "",
  editCheckNumber: "",
  setEditPayFrom: () => {},
  setEditPayTo: () => {},
  setEditMemo: () => {},
  setEditAmount: () => {},
  setEditCheckDate: () => {},
  setEditCheckNumber: () => {},
  toggleCollapsed: () => {},
  handleEdit: () => {},
  handleCancel: () => {},
  handleSave: async () => {},
  isSaving: false,
});

export default CheckDetailContext;
